import React, { createContext, useContext, ReactNode } from "react";
import { useChannelTalk, ChannelUserInfo } from "../hooks/useChannelTalk";

interface ChannelTalkContextType {
  openChat: () => void;
}

const ChannelTalkContext = createContext<ChannelTalkContextType | null>(null);

export const useChannelTalkContext = () => {
  const context = useContext(ChannelTalkContext);
  if (!context) {
    throw new Error(
      "useChannelTalkContext must be used within ChannelTalkProvider"
    );
  }
  return context;
};

interface ChannelTalkProviderProps {
  children: ReactNode;
  userInfo?: ChannelUserInfo | null;
  enabled?: boolean;
}

export const ChannelTalkProvider = ({
  children,
  userInfo,
  enabled = true,
}: ChannelTalkProviderProps) => {
  const { openChat } = useChannelTalk(userInfo, enabled);

  return (
    <ChannelTalkContext.Provider value={{ openChat }}>
      {children}
    </ChannelTalkContext.Provider>
  );
};
